import { cn } from '@/lib/utils';

import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { Text } from '@/decodo/components/atoms/Text';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

type FeaturesBlockProps = {
  features: {
    title: string;
    description: string;
  }[];
};

export const FeaturesBlock = ({ features }: FeaturesBlockProps) => {
  return (
    <BlockWrapper
      data-tracker-section={SECTION_NAMES.FEATURES_BLOCK}
      classNames={{ root: 'bg-gray-25 dark:bg-gray-dark-950' }}
      contentFit='mid'
    >
      <div className='bg-base-white dark:bg-gray-dark-900 dark:border-gray-dark-600 flex flex-col rounded border border-gray-200 px-5 py-6 lg:flex-row lg:px-10'>
        {features.map((feature, index) => (
          <div
            key={index}
            className={cn(
              'dark:border-gray-dark-600',
              'flex flex-1 flex-col items-center justify-center text-center',
              'border-b border-gray-200 px-4 py-6',
              'first:pl-0 first:pt-0 last:pb-0 last:pr-0 lg:py-0',
              'last:border-b-0 last:border-r-0 lg:border-b-0 lg:border-r'
            )}
          >
            <Text className='text-h2 dark:text-base-dark-white font-serif text-gray-950'>
              {feature.title}
            </Text>
            <Text
              color='gray-500'
              classNames={{
                wrapper: 'dark:text-gray-dark-400 font-mono',
              }}
            >
              {feature.description}
            </Text>
          </div>
        ))}
      </div>
    </BlockWrapper>
  );
};
